import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";

import { StyledFooterFlowButtons } from "./styled";

export type NavigationButtonTranslations = {
    next?: string;
    previous?: string;
};

type FooterFlowButtonsProps = {
    onBack?: () => void;
    onNext: () => void;
    canBack?: boolean;
    canNext?: boolean;
    disableNavigation?: boolean;
    disableNext?: boolean;
    translations?: NavigationButtonTranslations;
};

const FooterFlowButtons: FC<FooterFlowButtonsProps> = ({
    onBack,
    onNext,
    canNext = true,
    canBack = true,
    disableNavigation = false,
    disableNext = false,
    translations,
}) => {
    const { t } = useTranslation();

    const prevLabel = (translations?.previous && t(translations.previous)) || t("Common.Previous");
    const nextLabel = (translations?.next && t(translations.next)) || t("Common.Next");

    const backAllowed = canBack && onBack;
    const nextAllowed = canNext && onNext;

    return (
        <StyledFooterFlowButtons>
            {backAllowed && (
                <Button disabled={disableNavigation} data-testid="button-previous" variant="outlined" onClick={onBack}>
                    {prevLabel}
                </Button>
            )}

            {nextAllowed && (
                <Button
                    disabled={disableNavigation || disableNext}
                    data-testid="button-next"
                    style={{ marginLeft: "auto" }}
                    onClick={onNext}
                >
                    {nextLabel}
                </Button>
            )}
        </StyledFooterFlowButtons>
    );
};

export default FooterFlowButtons;
